import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const HostMaintenance = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='HostMaintenance' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M14,23 L20,17 M21,14 C19.8954305,14 19,14.8954305 19,16 C19,17.1045695 19.8954305,18 21,18 C22.1045695,18 23,17.1045695 23,16 M17,4 L18,4 L18,5 L17,5 L17,4 Z M10,23 L3,23 L3,1 L3,1 L21,1 L21,11 M3,13 L17,13 M3,18 L13,18 M3,8 L21,8' />
  </StyledIcon>
);
